import type { ButtonHTMLAttributes, ReactNode } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger" | "outline";
  size?: "sm" | "md" | "lg";
  children: ReactNode;
}

const variantStyles: Record<NonNullable<Props["variant"]>, string> = {
  primary: "bg-indigo-600 text-white hover:bg-indigo-500 shadow-sm ",
  secondary: "bg-slate-100 text-slate-700 hover:bg-slate-50 shadow-sm ",
  ghost: "bg-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-900 ",
  danger: "bg-rose-600 text-white hover:bg-rose-500 shadow-sm shadow-rose-900/20 ",
  outline: "bg-transparent border border-slate-200 text-slate-500 hover:border-slate-300 hover:text-slate-900 ",
};

const sizeStyles: Record<NonNullable<Props["size"]>, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-base",
};

export default ({ variant = "primary", size = "md", className, children, ...props }: Props) => {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variantStyles[variant]} ${sizeStyles[size]} ${className ?? ""}`}
      {...props}
    >
      {children}
    </button>
  );
};
